import http from './http';

const BASE_PATH = '/api/v1/hr';

const cleanParams = (params = {}) => {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (typeof value === 'string' && value.trim() === '') {
      return;
    }
    cleaned[key] = value;
  });
  return cleaned;
};

const extractData = (response) => response?.data?.data ?? null;

const handleApiError = (error) => {
  const response = error?.response?.data;
  const message = response?.message || response?.error || error?.message || 'Request failed';
  
  // Handle validation errors with detailed field information
  if (response?.errors && Array.isArray(response.errors)) {
    const details = response.errors
      .map((item) => {
        if (item?.field && item?.message) {
          return `${item.field}: ${item.message}`;
        }
        return item?.message || String(item);
      })
      .filter(Boolean)
      .join('\n');
    throw new Error(details ? `${message}\n\n${details}` : message);
  }
  
  // Handle single error message
  throw new Error(message);
};

export const hrAPI = {
  async getStats() {
    try {
      const response = await http.get(`${BASE_PATH}/stats`);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  // Attendance
  async listAttendance(params = {}) {
    try {
      const response = await http.get(`${BASE_PATH}/attendance`, {
        params: cleanParams(params)
      });
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async getAttendanceById(id) {
    try {
      const response = await http.get(`${BASE_PATH}/attendance/${id}`);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async createAttendance(payload) {
    try {
      const response = await http.post(`${BASE_PATH}/attendance`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async updateAttendance(id, payload) {
    try {
      const response = await http.patch(`${BASE_PATH}/attendance/${id}`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async deleteAttendance(id) {
    try {
      const response = await http.delete(`${BASE_PATH}/attendance/${id}`);
      return response?.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Salary
  async listSalaries(params = {}) {
    try {
      const response = await http.get(`${BASE_PATH}/salary`, {
        params: cleanParams(params)
      });
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async getSalaryById(id) {
    try {
      const response = await http.get(`${BASE_PATH}/salary/${id}`);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async createSalary(payload) {
    try {
      const response = await http.post(`${BASE_PATH}/salary`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async updateSalary(id, payload) {
    try {
      const response = await http.patch(`${BASE_PATH}/salary/${id}`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async deleteSalary(id) {
    try {
      const response = await http.delete(`${BASE_PATH}/salary/${id}`);
      return response?.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  // Payroll
  async listPayrolls(params = {}) {
    try {
      const response = await http.get(`${BASE_PATH}/payroll`, {
        params: cleanParams(params)
      });
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async getPayrollById(id) {
    try {
      const response = await http.get(`${BASE_PATH}/payroll/${id}`);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async calculatePayroll(payload) {
    try {
      const response = await http.post(`${BASE_PATH}/payroll/calculate`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async createPayroll(payload) {
    try {
      const response = await http.post(`${BASE_PATH}/payroll`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async updatePayroll(id, payload) {
    try {
      const response = await http.patch(`${BASE_PATH}/payroll/${id}`, payload);
      return extractData(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async deletePayroll(id) {
    try {
      const response = await http.delete(`${BASE_PATH}/payroll/${id}`);
      return response?.data;
    } catch (error) {
      handleApiError(error);
    }
  }
};

export default hrAPI;
